module.exports = __webpack_public_path__ + "static/media/AoA_HomeSections_Bg05-sm.20dabd12.jpg";